import styled from '@emotion/styled'

const Main = styled.main`
  padding: 2.5em 3em;
  flex: 1;
  max-width: 100%;
  box-sizing: border-box;
  position: relative;

  background: ${props => props.theme.primaryLight[props['data-color']] ?? 'none'};
  color: ${props => props.theme.primaryDark[props['data-color']] ?? 'currentColor'};
  border-top: ${props => `1em solid ${props.theme.primary[props['data-color']]}` ?? 'none'};

  ${props => props.center && `
    width: 500px;
    max-width: 100%;
    margin: 0 auto;
  `}

  @media (max-width: ${props => props.theme.mobileBreakpoint}) {
    padding: 1em;
  }
`

export default Main